<template>
  <span class="datecell">{{ params.value | toDate}}</span>
</template>

<script>
export default {
  name: "date-cell"
};
</script>